import { render, staticRenderFns } from "./AreaPanel.vue?vue&type=template&id=35fb2bec&scoped=true"
import script from "./AreaPanel.vue?vue&type=script&lang=js"
export * from "./AreaPanel.vue?vue&type=script&lang=js"
import style0 from "./AreaPanel.vue?vue&type=style&index=0&id=35fb2bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb2bec",
  null
  
)

export default component.exports